export const validEventOverviewQuery = {
  bool: {
    must: [
      { exists: { field: 'subeventId' } },
      { exists: { field: 'eventDisplayName' } },
      { exists: { field: 'teamData' } },
    ],
  },
};
